export const AI_GOVERNANCE_ICON_LABEL = 'AI governance'
